import React from 'react';
import moment from 'moment';
import { mediaRevenueStatistics } from 'lib/api/media';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import TableContainer from 'components/molecules/MbTable';
import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

const style = (theme) => ({});

let initialization = false;
let initParam = {
  sDate: moment().format('YYYYMMDD'),
  eDate: moment().format('YYYYMMDD'),
};

class MediaRevenueStatistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      params: initParam,
      list: [],
      revenueList: [],
      infoMessage: '',
      listCustomized: {},
      loading: false,
    };
  }

  componentDidUpdate(prevState) {
    // const { params: prevParams } = prevState;
    // const { params } = this.state;
  }

  /**
   * 필터 선택 관련
   */
  handleOnchangeFilter = (filterParam) => {
    const { params } = this.state;
    this.setState({
      ...this.state,
      params: { ...params, ...filterParam },
    });
  };

  /**
   * 필터 초기화
   */
  handleOnReset = () => {
    initialization = true;
    this.setState({
      ...this.state,
      params: { ...initParam },
    });
  };

  getParam = (newParams) => {
    const { getInitParam } = this.state;

    initialization = false;
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }

    this.setState({
      ...this.state,
      getInitParam: true,
      params: {
        ...this.state.params,
        ...newParams,
      },
    });
  };

  render() {
    const { handleOnReset, getParam } = this;
    const { classes } = this.props;
    const { params, listCustomized, getInitParam } = this.state;

    return (
      <>
        <FilterWrap handleOnReset={handleOnReset}>
          <StatisticsCommonFilter
            initialization={initialization}
            getParam={getParam}
            initData={initParam}
            noneExternalFilter={true}
          />
        </FilterWrap>
        {getInitParam && (
          <>
            <TableContainer
              className={classes.root}
              dataReqPromise={mediaRevenueStatistics}
              params={{ ...params }}
              sort="desc"
              order="ADVRTS_AMT"
              dense={true}
              customized={listCustomized}
              hasExcel
              hasTotal
              noneSearch={true}
            />
          </>
        )}
      </>
    );
  }
}

export default withTranslation()(withStyles(style)(MediaRevenueStatistics));
